import { render, staticRenderFns } from "./ReviewGreet.vue?vue&type=template&id=7df49322&scoped=true"
import script from "./ReviewGreet.vue?vue&type=script&lang=js"
export * from "./ReviewGreet.vue?vue&type=script&lang=js"
import style0 from "./ReviewGreet.vue?vue&type=style&index=0&id=7df49322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df49322",
  null
  
)

export default component.exports